export const MAIN_PALETTE: string[] = [
  '#315873',
  '#3A739F',
  '#8AB6D7',
  '#C792C2',
  '#DBB1D7',
  '#D8C0D6',
  '#C8BFE0',
  '#9B84DB',
]

export const initTheme = (type: 'dark' | 'light') => ({
  textColor: type === 'dark' ? 'white' : 'black',
  labels: {
    text: {
      fill: type === 'dark' ? 'white' : 'black',
      fontSize: '10px',
    },
  },
  axis: {
    ticks: {
      text: {
        color: type === 'dark' ? 'white' : 'black',
        fill: type === 'dark' ? 'white' : 'black',
        fontSize: '12px',
      },
    },
  },
  tooltip: {
    basic: {
      color: 'black',
    },
  },
  legends: {
    text: {
      fill: type === 'dark' ? 'white' : 'black',
      fontSize: '16px',
    },
  },
})
